import { color } from "../../common";
import PrintBlock from "../base/Block";
import BlockHeading from "../base/Heading";
import BlockRowContent from "../base/RowContent";

export default function ToBlock({
    toHeading = "Quote to",
    toHeadingArabic = "عرض السعر إلى",
    full_name,
    full_name_ar,
    company_address,
    address_ar,
    vat_number,
    email,
    cr_number,
}: {
    full_name: string;
    full_name_ar: string;
    company_address: string;
    address_ar: string;
    vat_number: string;
    email: string;
    cr_number: string;
    toHeading?: string;
    toHeadingArabic?: string;
}) {
    return (
        <PrintBlock
            style={{
                flex: "1",
                backgroundColor: color.bg,
                marginLeft: "2px",
                padding: "10px",
                borderRadius: "4px",
            }}
        >
            <BlockHeading
                arabicTitle={toHeadingArabic}
                englishTitle={toHeading}
            />

            <BlockRowContent
                arabicLabel="الاسم"
                englishLabel="Name"
                content={full_name || "N/A"}
                contentInArabic={full_name_ar || ""}
                boldContent={true}
            />

            <BlockRowContent
                englishLabel="Address"
                arabicLabel="العنوان"
                content={company_address || ""}
                contentInArabic={address_ar || ""}
                style={{ marginBottom: "10px" }}
            />
            <BlockRowContent
                arabicLabel="الرقم الضريبي"
                englishLabel="VAT No"
                content={vat_number || "N/A"}
                disableArabicContent
            />
            <BlockRowContent
                arabicLabel="بريد الالكتروني"
                englishLabel="Email"
                content={email || "N/A"}
                disableArabicContent
            />
            <BlockRowContent
                englishLabel="CR No"
                arabicLabel="السجل التجاري"
                content={cr_number || "N/A"}
                disableArabicContent
            />
        </PrintBlock>
    );
}
